<template>
<div class='orderRead max-width'>

	<!-- 左侧导航栏 -->
	<!-- <div class='orr_menu'>
		<template v-for='(item,index) in orr_menu'>
			<div :key='item.id' class='orr_menu_model'>
				<div class='orr_menu_mod_title font-16 color-body fontweight-bo'>{{item.title}}</div>
				<template v-for='(obj,seq) in item.data'>
					<div :key='obj.id' 
						 :class="{'orr_menu_mod_line font-14 bg-hoer-shallow':true, 'bgcolor-shallow':obj.choose, 'color-prompt-deep':!obj.choose}" 
						 :data-index='index' 
						 :data-seq='seq' 
						 @click='func_menu' 
						 >{{obj.name}}
					</div>
				</template>
			</div>
		</template>
	</div> -->
	<v-afficheSidebar></v-afficheSidebar>


	<!-- 右侧主体内容 -->
	<div class='orr_model'>
		<template v-for='item in orr_list'>
			<div v-if='item.title' 
				 :key='item.id' 
				 class='orr_model_title theme-fontcolor-bo-02' 
				 >{{item.title}}
			</div>
			<div v-if='item.list' 
				 :key='item.id' 
				 >
				 <div v-for='(item,index) in item.list' :key='item' class='orr_model_line theme-font-body-bo-04'>
					<div class='orr_model_li_index'>{{index+1}}.</div>
					<div class='orr_model_li_content'>{{item}}</div>
				</div>
			</div>
		</template>
	</div>

</div>
</template>
<script>
export default {
	name: 'orderRead',
	props: {},
	data() {
		return {
			orr_list: [
				{title: '尊敬的客户，为了双方的效率，彩航温馨提示您认真阅读以下下单必看内容，多有不便，敬请谅解。'},
				{title: '本公司印刷接收文件为X4版本，系统自动识别审稿！'},
				{title: '渐变、透明度、立体投影等复杂效果发生变化机率较大，请转换为位图。'},
				{title: '请用CMYK填色，所有专色及RGB填色引起的色差变化不给予售后处理，望各位同行知悉。'},
				{title: '色情、不法宗教、代开发票、批评国家等等都不可以印刷，如下单违法印刷品，因自动审稿没发现导致印刷完成的，我们将直接没收销毁，货款照收，请各同行别存在侥幸心态，感谢配合！ '},
				{title: '一、关于标准宣传单用纸、数量及尺寸说明'},
				{
					list: [
						'克数为不足克，要求高可索要纸样、提供样版或下专版印刷，不以纸张厚度为理由退货或补货；',
						'实际A4尺寸因裁切会有误差，标准宣传单尺寸在207X282正负1MM，均不在售后退补货范围之内，对尺寸要求严格的客户请先与客服沟通或下专版印刷。',
						'特价类宣传单为不足数，成品数量与下单数量±5为正常损耗，望知悉。',
					]
				},
				{
					title: '二、关于设计、填色、成品颜色偏差、套印的标准说明',
				},
				{
					list: [
						'关键内容切勿靠边。关键内容（文字等重要内容）最少距边3mm以上，裁切出来才比较美观，距边低于3mm的容易造成裁到关键内容，我司不予客诉。',
						'四色黑/四色灰填色导致套位不准，模糊重影，解决方案：文字改单黑，文字严禁四色黑填色，由此填色导致的重影问题、脏版、过底不在客诉之内。',
						'二维码改单黑方法：选中二维码，选择点阵图，颜色模式设置为：黑白（1位）分辨率300，转图即可',
						'叠印填色导致印刷变色。使用叠印填色导致印刷变色，首先客户没有理解叠印填色的效果和用处，胡乱使用或者不小心点击到，标准印刷严禁使用此类填色，引起的变化不在客诉之内，不退不补。',
						'使用GRB图片导致输出变色及色差案例，解决方案：更改为CMYK四色模式，分辨率350即可解决，同时可解决RGB图片印刷色差问题，因为最终印刷颜色以CMYK模式为接近色的. 步骤：选中图片——ALT+B位图--选择350分辨--颜色模式CMYK 确定即可',
						'印刷案例分析：隐藏图片导致印刷变化。此类问题发生原因多数是因为图片是从网页上复制的，再导入到CDR里之后没有转点阵图。发生机率随机，解决方案：做到所有cdr里的图片要转图，步骤：选中图片——ALT+B位图--选择350分辨--颜色模式CMYK 确定即可。别小看转图这个小细节，几乎可以避免百分之九十cdr文件里因为图片而产生的问题：如掉图，破图，变图，图片印刷效果与显示器显示色差大等等问题。',
						'图像框精确剪裁设计易出问题。图像框精确剪裁须锁定图框精确剪裁内容，因未锁定导致处理文件出现的掉图情况，一律不在客诉之内，由客户自行负责，解决方案：移动设计图框对比前后变化即可发现有锁定。',
						'大色块单黑要注意。大色块单黑下面不能填充其他颜色，还有色块黑色下面一边压颜色不边不压颜色，由于印刷需要我们在出版时会自动叠印黑色，这样就会造成下面的颜色叠印出来，解决方案：单黑填色K99 或者C30 M20 Y10 K100此类填色即可解决。',
						'文件摆放与单、双面关系。正面摆在左边，反面摆在右边，单面的一竖摆放，哪怕双面内容一样的也一定要反面内容复制到右边摆放好，只放一面内容然后在下面用文字标明要印双面无效，系统不会把单面的文件印成双面。',
					]
				},
				{
					title: '三、质量问题售后处理说明',
				},
				{
					list: [
						'不承担因印刷品错误而带来的连带损失(开业、参加会议、展会等)，出现问题我们会跟客户尽量沟通、补救，对重要用途印刷品望客户提前准备做好检查。',
						'所有问题类印刷品客诉时间为10天(本公司客户文件保存时间为10天，如时间过久无法查找印刷发生的原因就无法对出错的部门问责，有些问题没有原文件也无法找出发生的原因)望客户在发现质量问题第一时间和本公司沟通。',
						'原则上所有质量问题退货/补货须退回原货，需快递出去的货物望客户在发货之前做好检查，本公司不对此产生的运费承担责任。',
						'补货的订单请与客服沟通，无须重新上传文件，如重新上传视作新单操作。',
						'以上规则适用于彩航所有产品售后规则，特殊情况可酌情处理。',
					]
				},
				{
					title: '四、色差说明',
				},
				{
					list: [
						'彩航印刷建立了标准化的色彩管理连线系统CIP3，通过严格的生产环节控制，确保印刷品达到标准的色彩。',
						'显示器与印刷品之间的色差：显示器是由红、绿、蓝光组合成各种颜色，不同的显示器及同一台显示器在不同的环境下都呈现出非常大的颜色差异。而胶印是由青、品、黄、黑油墨叠印组成各种颜色，显色能力小于红、绿、蓝光的组合。所以，非专业显示器与印刷品之间会存在一定色差，请勿以显示器上的颜色评定印刷品。',
						'纸张不同产生的色差：相同的色值印在不同的纸张上所显示的颜色均会出现差异，论颜色是否出现偏色须在相同的纸张下对比。',
						'数码印刷与传统四色印刷之间的色差：数码直印和四色印刷是两种完全不同的生产方式，传统四色印刷和数码印刷的颜色无对比性，特别是双胶纸或特种纸。',
						'同批次之间的色差：胶印机的波动性，就同批次的印刷品之间也会存在一定色差，如果对颜色要求严格的订单，请客户提前跟客服人员说明，并提供色样，您也可以和客服预约来工厂现场看色印刷。',
						'彩航印刷标准化部门确保使用同一品牌、型号的印刷原料，并且对每批原料的品质严格检查，避免原材料对色彩的影响。但是因为季节温度、温度对印刷机的影响，不同批次印刷存在一定的色差属于正常现象。',
						'如何尽量避免出现色差',
						'请您使用专业的印刷设计软件，推荐使用corelDRAW X4，完成平面设计制作；',
						'设计开始前，检查设计软件的颜色类型设定，请使用CMKY色盘设计填色；',
						'尽量少的使用会产生明显色差的颜色比如蓝紫色、墨绿色、咖啡色等，在填黑色时避免填成四色黑(即:C:100,M:100,Y:100,K:100)，填四色黑色值的文字会造成叠印套位不准导致重影，大墨位四色黑会造成难干粘花；',
						'如果您对印刷颜色有任何疑问，请您与客服联系，我们安排专业人员为您解答。',
					]
				},
				{
					title: '五、信封印前须知',
				},
				{
					list: [
						'本厂库存纸：100克、120克双胶，100克、120克牛皮，如选用其他纸张出货时间可能会有所延迟',
						'相同色值，双胶纸比双铜纸的颜色深15%左右，设计时请注意；',
						'注意底纹与底色的色值要相差30%以上才能显示出来；',
						'由于双胶纸吸墨性强，如有大色块，会导致难干且粘花、压印到另一个信封；',
						'文件请注明中、西封、中封默认右边开口，西封默认上边开口，特殊要求请注明；',
						'除正面内容外，上下内容要旋转180度；',
						'粘位尽量不要填色块以免胶水粘性度减弱，导致粘合不良，注意粘位粘合后是否会盖到有内容；',
						'每次印刷会有一定色差，恕不退化，颜色要求高的请开专版跟色印刷。',
					]
				}
			]
		}
	},
	methods: {
		func_menu(event) {
			const index = event.currentTarget.dataset.index;
			const seq = event.currentTarget.dataset.seq;
			if (!this.orr_menu[index]['data'][seq]['choose']) {
				for (let i in this.orr_menu[index]['data']) {
					if (this.orr_menu[index]['data'][i]['choose']) {
						this.orr_menu[index]['data'][i]['choose'] = false;
						this.orr_menu[index]['data'][seq]['choose'] = true;
						break;
					}
				}
			}
		}
	}
}
</script>
<style src='@/style/orderRead.css'></style>
<style src='@/style/orderRead-h5.css'></style>


// WEBPACK FOOTER //
// src/pages/OrderRead.vue